<template>
  <div class="header">
    <div class="logo" @click="goToExpos">
      <span class="logo-log">Log</span><span class="logo-sep">-</span><span class="logo-expo">Expo</span>
    </div>
    <div class="user">
      <q-btn outlined dense color="pink-10" @click="logOut" icon="logout">Se deconnecter</q-btn>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();

    const goToExpos = () => {
      router.push('/admin');
    };

    const logOut = async () => {
      try {
        console.log("LogOut");
        router.push('/');  // Redirect to the root page after logout
      } catch (error) {
        console.log(error);
      }
    };

    return {
      goToExpos,
      logOut
    };
  }
};
</script>


<style>
.body {
  font-family: coda;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
  height: 40px;
}

.user {
  flex-basis: 20%;
}

.logo {
  display: flex;
  align-items: center;
  margin-left: 16px;
  cursor: pointer;
  user-select: none;
  font-size: 1.5em;
  letter-spacing: 1px;
  transition: opacity 0.2s;
}

.logo:hover {
  opacity: 0.75;
}

.logo-log {
  font-weight: 800;
  color: #1a1a2e;
  text-transform: uppercase;
  font-family: 'Segoe UI', Arial, sans-serif;
}

.logo-sep {
  color: #e91e63;
  font-weight: 300;
  margin: 0 1px;
}

.logo-expo {
  font-weight: 300;
  color: #555;
  font-style: italic;
  font-family: 'Segoe UI', Arial, sans-serif;
}
</style>